export const GET_AFFILIATE = "GET_AFFILIATE";
export const BLOCK_UNBLOCK_AFFILIATE = "BLOCK_UNBLOCK_AFFILIATE";
export const DELETE_AFFILIATE = "DELETE_AFFILIATE";
export const GET_SINGLE_AFFILIATE = "GET_SINGLE_AFFILIATE";